module.exports = __webpack_public_path__ + "media/src/website/images/locations/rimsting/rimsting_small_04-af752c330be3cfa5049263f35fc13531.jpg";